export const DEFAULT_SCOPES = ['openid', 'profile', 'email', 'nexus_roles', 'offline_access'];
export const TOKEN_RENEW_WINDOW_SECONDS = 60;
